export default __webpack_public_path__ + "media/images/wing_sprite-cb0bc87c61781b447fbc1f03269e8db1.png";